import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal } from 'Components/utility';
const mapState = ({ nav: { location, initErrorStatus, initErrorCode, redirect_uri }, }) => {
    return {
        initErrorStatus,
        initErrorCode,
        redirect_uri,
        location,
    };
};
const connector = connect(mapState);
const App = ({ initErrorStatus, initErrorCode, redirect_uri, location }) => {
    const { Component, props } = useRouter(location, initErrorStatus, initErrorCode, redirect_uri);
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, { ...props }),
        React.createElement(GeneralModal, null)));
};
export default connector(App);
